import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_USERS_REQUEST,
    getUsersSuccess,
    getUsersFailure
} from "../actions/getUsers"

function* getUsersSaga(action) {
    console.log(action)
    try {
        const response = yield call(api_service.getUsers, action.payload);
        yield put(getUsersSuccess(response));
    } catch (err) {
        console.log(err);
        yield put(getUsersFailure(err.response?.data?.message || 'failed'));
    }
}

export default function* watchGetUsersSaga() {
    yield takeEvery(GET_USERS_REQUEST, getUsersSaga);
}
